import React from 'react';
import Col from '../../Grid/Col.js';
export const Box = (props) => {
    return (React.createElement(Col, { width: "6" },
        React.createElement("h3", { style: {
                fontSize: '0.9em',
                opacity: 0.65,
            } }, props.header),
        React.createElement("p", { style: { fontFamily: 'JetBrains Mono, monospace' } },
            React.createElement("code", null, props.body))));
};
//# sourceMappingURL=Helpers.js.map